// Tracks whether this SPA session has rendered more than one distinct route
// since the JS bundle booted. document.referrer only reflects the browser's
// actual last full-page-load referrer -- it is frozen the instant a
// client-side route change (a <Link>, navigate(), or a redirect component
// with no document reload) happens, so it can go stale relative to whatever
// screen the user was actually just looking at.
//
// A per-link opt-in marker (e.g. a <Link state={{ from: location }}>) only
// covers links that remember to set it -- AppSidebar's "Give Now" link, for
// instance, reaches the giving page through MyGivingRedirect.tsx without
// ever setting one (Codex P2, PR #6402). This module tracks it globally
// instead: <SpaNavigationTracker /> (rendered once, near the app's root,
// inside the router) records every route render, and any code that needs to
// know "was document.referrer possibly superseded by an in-app transition"
// can ask this module directly, independent of which specific link or
// redirect got the user here.
//
// Deliberately plain module state, not React state: nothing here needs to
// trigger a re-render, and module-level state resets exactly once per hard
// page load (the whole bundle re-executes from scratch), which is the
// property that makes "has more than one route been rendered yet" a
// reliable signal in the first place -- a genuine fresh load always starts
// this set back at empty, while an SPA-internal transition never does.
//
// Recorded by react-router's location.key rather than a bare counter:
// src/main.tsx wraps the app in React.StrictMode, which deliberately
// double-invokes mount effects in development, so a single, real initial
// render would otherwise be counted twice before any navigation ever
// happened -- flipping hasSpaNavigated() true on a plain hard load and
// silently discarding a real document.referrer for every anonymous donor
// running the app locally (Codex P2, PR #6402, round 5). StrictMode's
// second invocation re-renders the SAME location, so it reports the SAME
// key -- a Set absorbs the duplicate for free, and only a genuinely
// different key (an actual navigation) grows it past one entry.
const seenLocationKeys = new Set<string>();

export function recordRouteRender(locationKey: string): void {
  seenLocationKeys.add(locationKey);
}

export function hasSpaNavigated(): boolean {
  return seenLocationKeys.size > 1;
}
